/*
 * @Author: Junchi Zhao
 * @LastEditors: 金经义 jinjy@epsoft.com.cn
 * @Description:
 */
export default {
  components: {
    //进展组件
    progressComponent: () => import('@/views/flow/diagram/progressComponent'),
    // 审批意见
    opininComponent: () => import('@/views/flow/opinionEntListComponent.vue')
  }
};
